import { Routes } from '@angular/router';
import { AuthenticationGuard } from '@app/core';

import { UsuariosComponent } from './usuarios/usuarios.component';
import { CategoryComponent } from '@app/dashboard/category/category.component';
import { ProductsComponent } from '@app/dashboard/products/products.component';
import { WarehouseComponent } from '@app/dashboard/warehouse/warehouse.component';
import { ClientComponent } from '@app/dashboard/client/client.component';
import { OrderComponent } from '@app/dashboard/order/order.component';
import { CreateOrderComponent } from './order/order/create-order.component';
import { OrderEditComponent } from './order/order-edit/order-edit.component';
import { ExpenseComponent } from '@app/dashboard/expense/expense.component';
import { ExpenseListComponent } from '@app/dashboard/expense/expense-list/expense-list.component';
import { ExpenseCreateComponent } from '@app/dashboard/expense/expense-create/expense-create.component';
import { DashboardComponent } from '@app/dashboard/dashboard';
import { ReportesComponent } from './reportes/reportes.component';
import { ExistenciaComponent } from './reportes/existencia/existencia.component';
import { VentaComponent } from '@app/dashboard/reportes/venta/venta.component';
import { GastoComponent } from '@app/dashboard/reportes/gasto/gasto.component';
import { UnityComponent } from '@app/dashboard/unity/unity.component';
import { OrderDetailsComponent } from './order/order-details/order-details.component';
import { VentasComponent } from './ventas/ventas.component';
import { PreciosComponent } from './reportes/precios/precios.component';
import { PedidosComponent } from './reportes/pedidos/pedidos.component';
import { DeudasComponent } from './reportes/deudas/deudas.component';
import { AlmacenComponent } from './reportes/almacen/almacen.component';
import { ReporteVentasComponent } from './reportes/reporte-ventas/reporte-ventas.component';
import { MonetizadoComponent } from './reportes/monetizado/monetizado.component';
import { SeguimientoComponent } from './reportes/seguimiento/seguimiento.component';
import { ProformasComponent } from './proformas/proformas.component';
import { CreateproformaComponent } from './proformas/createproforma/createproforma.component';
import { EditproformaComponent } from './proformas/editproforma/editproforma.component';
import { CobranzasComponent } from './reportes/cobranzas/cobranzas.component';
import { ListarVisitasComponent } from './client/listar-visitas/listar-visitas.component';
import { VisitasComponent } from './visitas/visitas.component';
import { PagoProveedorComponent } from './pago-proveedor/pago-proveedor.component';
import { ProveedorService } from '@app/core/service/proveedor.service';
import { ProveedoresComponent } from './proveedores/proveedores.component';
import { ReporteVisitasComponent } from './reportes/reporte-visitas/reporte-visitas.component';
import { RPagoProveedoresComponent } from './reportes/r-pago-proveedores/r-pago-proveedores.component';

export const DashboardRoutes: Routes = [
  {
    path: '',
    canActivate: [AuthenticationGuard],
    children: [
      {
        path: '',
        component: DashboardComponent,
        data: {
          title: 'Dashboard',
          roles: ['administrador', 'almacen']
        }
      },
      {
        path: 'usuarios',
        component: UsuariosComponent,
        data: {
          title: 'Usuarios',
          roles: ['administrador']
        }
      },
      {
        path: 'categoria',
        component: CategoryComponent,
        data: {
          title: 'Categoria',
          roles: ['administrador']
        }
      },
      {
        path: 'productos',
        component: ProductsComponent,
        data: { title: 'Categorias', roles: ['administrador'] }
      },
      {
        path: 'almacen',
        component: WarehouseComponent,
        data: { title: 'Almacen', roles: ['administrador'] }
      },
      {
        path: 'clientes',
        component: ClientComponent,
        data: { title: 'Clientes', roles: ['administrador'] }
      },
      {
        path: 'visitas',
        component: VisitasComponent,
        data: { title: 'visitas', roles: ['administrador'] }
      },
      {
        path: 'order',
        component: CreateOrderComponent,
        data: { title: 'Pedidos', roles: ['administrador', 'vendedor'] }
      },
      {
        path: 'proforma',
        component: CreateproformaComponent,
        data: { title: 'Proformas', roles: ['administrador', 'vendedor'] }
      },
      {
        path: 'order-list',
        component: OrderComponent,
        data: { title: 'Pedidos', roles: ['administrador', 'vendedor'] }
      },
      {
        path: 'proforma-list',
        component: ProformasComponent,
        data: { title: 'Proformas', roles: ['administrador', 'vendedor'] }
      },
      {
        path: 'order-edit/:id',
        component: OrderEditComponent,
        data: { title: 'Pedidos', roles: ['administrador', 'vendedor'] }
      },
      {
        path: 'proforma-edit/:id',
        component: EditproformaComponent,
        data: { title: 'Proformas', roles: ['administrador', 'vendedor'] }
      },
      {
        path: 'order-details/:id',
        component: OrderDetailsComponent,
        data: { title: 'Detalles', roles: ['administrador', 'vendedor'] }
      },
      {
        path: 'expense',
        component: ExpenseComponent,
        data: { title: 'Gastos', roles: ['administrador'] }
      },
      {
        path: 'expense-list',
        component: ExpenseListComponent,
        data: { title: 'Gastos', roles: ['administrador'] }
      },
      {
        path: 'expense-create',
        component: ExpenseCreateComponent,
        data: { title: 'Gastos', roles: ['administrador'] }
      },
      {
        path: 'existencia',
        component: ExistenciaComponent,
        data: { title: 'Existencia', roles: ['administrador'] }
      },
      {
        path: 'productos-pedidos',
        component: PedidosComponent,
        data: { title: 'productos pedidos', roles: ['administrador'] }
      },
      {
        path: 'reporte-venta',
        component: VentaComponent,
        data: { title: 'Reporte Venta', roles: ['administrador'] }
      },
      {
        path: 'reporte-existencia',
        component: AlmacenComponent,
        data: { title: 'Reporte Existencia', roles: ['administrador'] }
      },
      {
        path: 'reporte-monetizado',
        component: MonetizadoComponent,
        data: { title: 'Reporte Monetizado', roles: ['administrador'] }
      },
      {
        path: 'reporte-cobranzas',
        component: CobranzasComponent,
        data: { title: 'Reporte Monetizado', roles: ['administrador'] }
      },
      {
        path: 'reporte-vendedor',
        component: ReporteVentasComponent,
        data: { title: 'Reporte Ventas', roles: ['administrador'] }
      },
      {
        path: 'reporte-gasto',
        component: GastoComponent,
        data: { title: 'Reporte Gasto', roles: ['administrador'] }
      },
      {
        path: 'reporte-deudas',
        component: DeudasComponent,
        data: { title: 'Reporte Deudas', roles: ['administrador'] }
      },
      {
        path: 'reporte-seguimiento',
        component: SeguimientoComponent,
        data: { title: 'Reporte Seguimiento', roles: ['administrador'] }
      },
      {
        path: 'reporte-precios',
        component: PreciosComponent,
        data: { title: 'Reporte Precios', roles: ['administrador'] }
      },
      {
        path: 'reporte-visitas',
        component: ReporteVisitasComponent,
        data: { title: 'Reporte Visitas', roles: ['administrador'] }
      },
      {
        path: 'unidades',
        component: UnityComponent,
        data: { title: 'Unidades', roles: ['administrador'] }
      },
      {
        path: 'ventas',
        component: VentasComponent,
        data: { title: 'Ventas', roles: ['administrador', 'almacen'] }
      },
      {
        path: 'pagos',
        component: PagoProveedorComponent,
        data: { title: 'Pagos', roles: ['administrador', 'almacen'] }
      },

      {
        path: 'listar-visitas',
        component: ListarVisitasComponent,
        data: { title: 'Visitas', roles: ['administrador'] }
      },
      {
        path: 'proveedores',
        component: ProveedoresComponent,
        data: { title: 'Proveedores', roles: ['administrador'] }
      },
      {
        path: 'r-pagos',
        component: RPagoProveedoresComponent,
        data: { title: 'Proveedores', roles: ['administrador'] }
      }
      

      // {
      //   path: 'crear-visitas',
      //   component: ListarVisitasComponent,
      //   data: { title: 'Visitas', roles: ['administrador'] }
      // },
    ]
  }
];
